// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"i_Ak","container":"i_Al","link":"i_Am","delimiter":"i_An"};